<template>
  <div v-if="printingInformation.length > 0"
    class="help-block"
    style="display: flex; align-items: flex-start;">
    <span><b>{{ $t('configurator.form.labels.notes') }}</b>:</span>
    <div style="display: flex; flex-wrap: wrap; align-items: flex-start;">
      <template v-for="document in printingInformation" :key="document.id">
        <a class="cursor--pointer pl-2" @click="download(document)">
          <em class="fa fa-file-pdf-o"></em> {{ (inEnglish) ? document.name_en : document.name }}
        </a>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { downloadFile } from '@/utils/file'

const store = useMainStore()
// define computed props
const locale = computed(() => store.settings.locale)
const printingInformation = computed(() => store.tmp.printing_information)
const exhibition = computed(() => store.tmp.exhibition_slug)

const inEnglish = computed(() => (locale.value === 'en'))
// define methods
const download = async (document) => {
  await downloadFile(
    '/' + exhibition.value + '/download/printing-information/' + document.identifier,
    ((inEnglish.value) ? document.name_en : document.name) + '.' + document.extension
  )
}
</script>